
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppDateTimePicker } from '@/components';
import { useBonusBoost } from '@/modules/bonus/boost/model/edit';
import { timeUnits } from '@/common/utils/helpers';
import { ROUTE_NAME_BONUS } from '@/modules/bonus/router';

export default defineComponent({
    name: ROUTE_NAME_BONUS.BOOST,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppDateTimePicker },
    setup() {
        const { model, v$, fetch, actions } = useBonusBoost();

        onMounted(() => {
            fetch();
        });

        return { v$, model, actions, timeUnits, types };
    }
});

const types = [
    { label: 'New Player', value: 1 },
    { label: 'Routine Player', value: 2 }
];
